import {
  createTask as CREATE_TASK,
  TaskDirection,
} from '@admiin-com/ds-graphql';
import { gql, useMutation } from '@apollo/client';
import {
  MutationTuple,
  OperationVariables,
  DefaultContext,
  ApolloCache,
} from '@apollo/client';
import { convertToBackendTask } from '../../helpers/tasks';

export type UseMutationTuple = MutationTuple<
  any,
  OperationVariables,
  DefaultContext,
  ApolloCache<any>
>;

export function useCreateTask(): [
  (options: any) => Promise<any>,
  { error: UseMutationTuple[1]['error'] }
] {
  const [createTaskMutation, { error }] = useMutation(gql(CREATE_TASK), {
    update(cache, { data: { createTask } }) {
      // 1) Write the new Task into the cache as a fragment
      const taskRef = cache.writeFragment({
        id: cache.identify({ __typename: 'Task', id: createTask.id }),
        fragment: gql`
          fragment NewTask on Task {
            id
            status
            direction
            type
            category
            invoiceStatus
            dueAt
            amount
            fromId
            toId
          }
        `,
        data: createTask,
      });

      // 2) Globally update any cached searchTasks queries
      cache.modify({
        fields: {
          searchTasks(existing) {
            // Only prepend if this query's variables match the new task
            const items = existing?.items || [];
            return {
              ...existing,
              items: [taskRef, ...items],
              total: (existing?.total || 0) + 1,
            };
          },

          searchTaskCounts(existing) {
            console.log('searchTaskCounts existing: ', existing);
            const counts = { ...(existing || {}) };
            counts.ALL = (counts.ALL || 0) + 1;
            if (createTask.category === 'TAX') {
              counts.TAX_BILLS = (counts.TAX_BILLS || 0) + 1;
            } else if (createTask.invoiceStatus === 'QUOTE') {
              counts.QUOTES = (counts.QUOTES || 0) + 1;
            } else if (
              createTask.type === 'SIGN_ONLY' ||
              (createTask.type === 'SIGN_PAY' && !createTask.category)
            ) {
              counts.ESIGNATURE = (counts.ESIGNATURE || 0) + 1;
            } else if (createTask.direction === TaskDirection.SENDING) {
              counts.INVOICES = (counts.INVOICES || 0) + 1;
            } else {
              counts.BILLS = (counts.BILLS || 0) + 1;
            }
            return counts;
          },

          // note - needs some work with selecting the right key
          // tasksOverdueCounts(existing) {
          //   console.log('tasksOverdueCounts existing: ', existing);
          //   const now = new Date();
          //   const dueAt = new Date(createTask.dueAt);
          //   console.log('dueAt < now', dueAt < now);
          //   if (
          //     dueAt < now
          //   ) {
          //     const overdue = { ...(existing || {}) };
          //     console.log('overdue: ', overdue);
          //     const key =
          //       createTask.category === 'TAX'
          //         ? 'TAX_BILLS'
          //         : createTask.direction === TaskDirection.SENDING
          //           ? 'INVOICES'
          //           : 'BILLS';
          //     console.log('key: ', key);
          //     console.log('overdue[key]: ', overdue[key]);
          //     const bucket = overdue[key] || { tasks: 0, clients: 0, amount: 0 };
          //     bucket.tasks += 1;
          //     bucket.amount += createTask.amount || 0;
          //     overdue[key] = bucket;
          //     return overdue;
          //   }
          //   return existing;
          // },
        },
      });
    },
    awaitRefetchQueries: true,
  });

  const createTask = async (options: any) => {
    // Convert the task variables to backend format before sending
    if (options.variables?.input) {
      options.variables.input = convertToBackendTask(options.variables.input);
    }
    return createTaskMutation(options);
  };

  return [createTask, { error }];
}
